{
  "components": {
    "actionItems": {
      "title": "All action items",
      "searchPlaceholder": "Find by title, assigned person",
      "noActionItems": "No action items",
      "noActionItemsDescription": "Add action item for an organization to see it here or try adjusting the filters to find relevant results.",
      "actionItemsCounter_one": "{{count}} Action item",
      "actionItemsCounter_other": "{{count}} items",
      "groupByList": {
        "completed": "Completed",
        "active": "Active"
      },
      "filters": {
        "myOrganizations": "My organizations"
      }
    },
    "actionItemForm": {
      "deleteAction": "Delete action",
      "placeholder": {
        "spendArea": "Select spend area"
      },
      "meetingDetails": "Action details",
      "uploadFile": "Action details",
      "linkDetails": "Link details",

      "fields": {
        "title": "Title",
        "description": "Description",
        "priority": "Priority",
        "stage": "Stage",
        "actionType": "Action type",
        "meetingLink": "Meeting link",
        "meetingDate": "Meeting date",
        "organization": "Organization",
        "spendArea": "Spend area",
        "assignee": "Assigned person",
        "deadline": {
          "label": "Due date",
          "description": "The date by which the action item must be completed"
        },
        "linkUrl": "Link URL",
        "file": "File",
        "notifyExternalClient": "Send notification email to assignee"
      },
      "header": {
        "edit": "Edit action",
        "create": "New action item",
        "preview": "Preview (read only)"
      },
      "submitButton": {
        "create": "Create",
        "edit": "Save"
      }
    },
    "actionItemList": {
      "blockedTooltip": "Only client result managers can edit action items",
      "emptyListMessage": "No action items",
      "emptyListMessageWithSearch": "There are no results for the phrase you are looking for. Please use another phrase and try again"
    }
  }
}
